/**
 * Format a sequential entity number for display.
 *
 * Without prefix — plain number, no padding:
 *   formatRef(1)    → "1"
 *   formatRef(42)   → "42"
 *
 * With prefix — entity refs (recordings, folders, IVR nodes, etc.):
 *   formatRef(1,  'REC') → "REC-1"
 *   formatRef(42, 'IVR') → "IVR-42"
 */
export function formatRef(n: number | string, prefix?: string): string {
  if (prefix) return `${prefix}-${n}`;
  return String(n);
}

/**
 * Build the URL segment for an entity that supports BOTH ref-form and
 * UUID URLs (after Sam's 2026-05-14 URL refactor). Prefer the
 * human-friendly ref when available; fall back to the UUID for legacy
 * rows that pre-date the per-entity ref_number migration.
 *
 *   routeRef({ id: '<uuid>', ref_number: 1 }, 'IVT') → 'IVT-1'
 *   routeRef({ id: '<uuid>', ref_number: null }, 'IVT') → '<uuid>'
 */
export function routeRef(
  row: { id: string; ref_number?: number | null },
  prefix: string,
): string {
  if (row.ref_number != null) return `${prefix}-${row.ref_number}`;
  return row.id;
}
